import { TranscriptSentence } from "@/shared/interfaces/Transcript";
import { SPEAKER_CONFIDENCE_THRESHOLD } from "../constants";

/**
 * Whether the AI's speaker-label confidence for this sentence is low enough to
 * flag for review. Legacy sentences (field absent / non-numeric) are never
 * flagged — the `typeof` check is what keeps this backwards compatible.
 */
export const isLowSpeakerConfidence = (s: TranscriptSentence): boolean =>
  typeof s.speakerConfidence === "number" &&
  s.speakerConfidence < SPEAKER_CONFIDENCE_THRESHOLD;
